import React from 'react';

import { Typography } from '@mui/material';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { StlPopup } from 'features/common/StlPopup/StlPopup';
import { stl_error_color } from 'theme/cemTheme';

interface DeleteAlertPopupProps {
  isOpen: boolean;
  alertName: string;
  routes: string[];
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteAlertPopup({
  isOpen,
  alertName,
  routes,
  onClose,
  onConfirm,
}: DeleteAlertPopupProps) {
  const routeCount = routes.length;

  return (
    <StlPopup
      isOpen={isOpen}
      onClose={onClose}
      onApply={onConfirm}
      title={
        <div>
          <FontAwesomeIcon
            type="sharp-solid"
            name="triangle-exclamation"
            sx={{ marginRight: '2px', color: stl_error_color }}
          />
          <span>Delete Alert ({alertName})</span>
        </div>
      }
      btnTxt="Delete"
      color="errorStl"
      isAlert
    >
      {routeCount == 1 ? (
        <Typography variant="body2">
          This alert is only linked to one route. Deleting it will remove it
          from {routes[0]}.
        </Typography>
      ) : (
        <Typography variant="body2">
          This alert is linked to {routeCount} other routes. Deleting it will
          remove it from all of them.
        </Typography>
      )}
    </StlPopup>
  );
}
